import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MaltaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15537'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15537)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.4766 14H20.0004V0H10.4766V14Z'
					fill='#DE233C'
				/>
				<mask
					id='path-4-outside-1_2332_15537'
					maskUnits='userSpaceOnUse'
					x='0.904297'
					y='0.866699'
					width='5'
					height='5'
					fill='black'>
					<rect
						fill='white'
						x='0.904297'
						y='0.866699'
						width='5'
						height='5'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M3.80906 1.8667H2.85668V2.80003H1.9043V3.73337H2.85668V4.6667H3.80906V3.73337H4.76144V2.80003H3.80906V1.8667Z'
					/>
				</mask>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.80906 1.8667H2.85668V2.80003H1.9043V3.73337H2.85668V4.6667H3.80906V3.73337H4.76144V2.80003H3.80906V1.8667Z'
					fill='#CCCCCD'
				/>
				<path
					d='M2.85668 1.8667V1.20003H2.19001V1.8667H2.85668ZM3.80906 1.8667H4.47573V1.20003H3.80906V1.8667ZM2.85668 2.80003V3.4667H3.52334V2.80003H2.85668ZM1.9043 2.80003V2.13337H1.23763V2.80003H1.9043ZM1.9043 3.73337H1.23763V4.40003H1.9043V3.73337ZM2.85668 3.73337H3.52334V3.0667H2.85668V3.73337ZM2.85668 4.6667H2.19001V5.33337H2.85668V4.6667ZM3.80906 4.6667V5.33337H4.47573V4.6667H3.80906ZM3.80906 3.73337V3.0667H3.14239V3.73337H3.80906ZM4.76144 3.73337V4.40003H5.42811V3.73337H4.76144ZM4.76144 2.80003H5.42811V2.13337H4.76144V2.80003ZM3.80906 2.80003H3.14239V3.4667H3.80906V2.80003ZM2.85668 2.53337H3.80906V1.20003H2.85668V2.53337ZM3.52334 2.80003V1.8667H2.19001V2.80003H3.52334ZM1.9043 3.4667H2.85668V2.13337H1.9043V3.4667ZM2.57096 3.73337V2.80003H1.23763V3.73337H2.57096ZM2.85668 3.0667H1.9043V4.40003H2.85668V3.0667ZM3.52334 4.6667V3.73337H2.19001V4.6667H3.52334ZM3.80906 4.00003H2.85668V5.33337H3.80906V4.00003ZM3.14239 3.73337V4.6667H4.47573V3.73337H3.14239ZM4.76144 3.0667H3.80906V4.40003H4.76144V3.0667ZM4.09477 2.80003V3.73337H5.42811V2.80003H4.09477ZM3.80906 3.4667H4.76144V2.13337H3.80906V3.4667ZM3.14239 1.8667V2.80003H4.47573V1.8667H3.14239Z'
					fill='#7B716A'
					fillOpacity='0.66'
					mask='url(#path-4-outside-1_2332_15537)'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.33361 3.73338C3.59661 3.73338 3.8098 3.52445 3.8098 3.26672C3.8098 3.00898 3.59661 2.80005 3.33361 2.80005C3.07062 2.80005 2.85742 3.00898 2.85742 3.26672C2.85742 3.52445 3.07062 3.73338 3.33361 3.73338Z'
					fill='#7B716A'
				/>
			</g>
		</svg>
	);
};

export default MaltaFlagIcon;
